// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import ScrollToTop from "./Components/ScrollToTop";

// ✅ Layout


// ✅ Pages
import AmpleHome from "./Components/AmpleHomeComponents/AmpleHome";
import AboutUsPage from "./Components/AboutUsComponents/AboutUsPage";
import ContactUsPage from "./Components/ContactUsComponents/ContactUsPage";
import AmpleProductionPage from "./Components/AmpleProductionsComponents/AmpleProductionPage";

import AmplePublicationPage from "./Components/AmplePublicationsComponents/AmplePublicationPage";
import RegistrationPage from "./Components/AmpleProductionsComponents/JourneyManPages/RegistrationPage";
import MainLayout from "./Components/MainLayout";

import AmpleEventPage from "./Components/AmpleEventComponents/AmpleEventPage";
import AmpleAcademyPage from "./Components/AmpleAcademyComponents/AmpleAcademyPage";
import InnerLeadershipRegPage from "./Components/AmpleLeaderShipComponents/InnerLeadershipRegPage";
import StoryFestPage from "./Components/StoryFestComponents/StoryFestPage";
import BelievePage from "./Components/StoryFestComponents/BelievePage";
import VendorPage from "./Components/StoryFestComponents/VendorPage";
import StoryFestRegistrationPage from "./Components/StoryFestComponents/StoryFestRegistrationPage";
import BelieveDaysPage from "./Components/StoryFestComponents/BelieveDaysPage";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
         
         <Route path="/storyfest" element={<StoryFestPage />}/>
         <Route path="/believe" element={<BelievePage />}/>
         <Route path="/vendors" element={<VendorPage />}/>
         <Route path="/register" element={<StoryFestRegistrationPage />}/>
         <Route path="/believe-days" element={<BelieveDaysPage/>}/>
        
        <Route element={<MainLayout />}>
          <Route path="/" element={<AmpleHome />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/ample-productions" element={<AmpleProductionPage />} />
          <Route path="/ample-event" element={<AmpleEventPage />} />
          <Route path="/ample-academy" element={<AmpleAcademyPage />} />
          
          <Route path="/ample-publications" element={<AmplePublicationPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          
        </Route>

        
        <Route path="/journeyman-2026-registration-rsvp" element={<RegistrationPage />}/>
        <Route path="/innerleadership-registration-rsvp" element={<InnerLeadershipRegPage />}/>


        

      </Routes>
    </Router>
  );
}

export default App;